import { OPEN_TRIP_STATUSES } from '@chukua/common';

export type TripAction = 'message' | 'capture' | 'reassign';

interface TripActionInputs {
  status: string;
  hasDriver: boolean;
  canDispatch: boolean;
  canCommunicate: boolean;
}

/** From dispatch until the driver's part is done: `assigned` has not been sent yet and an aborted or closed trip takes no more steps. */
const DRIVER_ACTIVE = OPEN_TRIP_STATUSES.filter((status) => status !== 'assigned') as readonly string[];

/**
 * Which buttons the page offers. Aborting has its own rule (`canOfferAbort`) and is not decided here. A crew can be changed here only
 * before dispatch; after it the crew changes by handover, which lives on the dispatch screen.
 */
export function availableTripActions(inputs: TripActionInputs): TripAction[] {
  const actions: TripAction[] = [];
  if (inputs.hasDriver && inputs.canCommunicate) actions.push('message');
  if (inputs.hasDriver && inputs.canDispatch && DRIVER_ACTIVE.includes(inputs.status)) actions.push('capture');
  if (inputs.canDispatch && inputs.status === 'assigned') actions.push('reassign');
  return actions;
}
